import React, { useState } from 'react';
import { Phone, Sparkles, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useToast } from '../hooks/use-toast';
import { POS_QUANTITIES, BUSINESS_TYPES, DISTRICTS_HP, DISTRICTS_UK } from '../mock/mock';

const LeadForm = () => {
  const [qty, setQty] = useState('2-5');
  const [bizType, setBizType] = useState('');
  const [district, setDistrict] = useState('');
  const [mobile, setMobile] = useState('');
  const { toast } = useToast();

  const submit = () => {
    if (!mobile || mobile.length < 10) {
      toast({ title: 'Enter a valid mobile number', description: 'Please provide a 10-digit mobile number to get the best offer.' });
      return;
    }
    toast({
      title: 'Request Received!',
      description: `We will call ${mobile} within 15 minutes with the best offer for ${qty} device(s).`,
    });
    setMobile('');
  };

  return (
    <div className="rounded-3xl bg-gradient-to-br from-[#3D1568] via-[#5F259F] to-[#7C3AED] p-6 lg:p-7 premium-shadow relative overflow-hidden">
      {/* decorative */}
      <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute -bottom-20 -left-16 w-56 h-56 rounded-full bg-violet-400/20 blur-2xl" />

      <div className="relative">
        <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur-md">
          <Sparkles className="w-3 h-3 text-amber-300" />
          <span className="text-[10px] font-bold text-white uppercase tracking-wider">Best Offer Inside</span>
        </div>

        <h3 className="mt-3 text-white text-xl lg:text-[22px] font-extrabold leading-tight">
          How many Smart POS (EDC) machines do you need?
        </h3>

        <div className="mt-4 grid grid-cols-4 gap-2">
          {POS_QUANTITIES.map((q) => (
            <button
              key={q}
              onClick={() => setQty(q)}
              className={`h-11 rounded-xl text-sm font-bold transition-all ${
                qty === q
                  ? 'bg-white text-[#5F259F] shadow-lg scale-[1.02]'
                  : 'bg-white/10 text-white border border-white/20 hover:bg-white/20'
              }`}
            >
              {q}
            </button>
          ))}
        </div>

        <div className="mt-5 space-y-3">
          <div>
            <label className="text-white/85 text-[12px] font-semibold">Your Business Type</label>
            <Select value={bizType} onValueChange={setBizType}>
              <SelectTrigger className="mt-1.5 bg-white/10 border-white/25 text-white h-11 rounded-xl backdrop-blur-md hover:bg-white/15">
                <SelectValue placeholder="Select Your Business Type" />
              </SelectTrigger>
              <SelectContent>
                {BUSINESS_TYPES.map((b) => (
                  <SelectItem key={b} value={b}>{b}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <label className="text-white/85 text-[12px] font-semibold">Your District</label>
            <Select value={district} onValueChange={setDistrict}>
              <SelectTrigger className="mt-1.5 bg-white/10 border-white/25 text-white h-11 rounded-xl backdrop-blur-md hover:bg-white/15">
                <SelectValue placeholder="Select Your District" />
              </SelectTrigger>
              <SelectContent>
                <div className="px-2 py-1 text-[11px] font-bold text-[#5F259F] uppercase">Himachal Pradesh</div>
                {DISTRICTS_HP.map((d) => (
                  <SelectItem key={`hp-${d}`} value={`HP - ${d}`}>{d}</SelectItem>
                ))}
                <div className="px-2 py-1 text-[11px] font-bold text-[#5F259F] uppercase mt-1">Uttarakhand</div>
                {DISTRICTS_UK.map((d) => (
                  <SelectItem key={`uk-${d}`} value={`UK - ${d}`}>{d}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center gap-2 bg-white rounded-xl h-11 px-3">
            <Phone className="w-4 h-4 text-[#5F259F]" />
            <input
              value={mobile}
              onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
              placeholder="Enter Mobile Number"
              className="flex-1 bg-transparent outline-none text-slate-900 text-sm placeholder:text-slate-400"
            />
          </div>
        </div>

        <Button onClick={submit} className="mt-4 w-full h-12 rounded-xl bg-white text-[#5F259F] font-extrabold hover:bg-purple-50 text-[15px] shadow-lg">
          Get My Best Offer <ChevronDown className="w-4 h-4 ml-1 -rotate-90" />
        </Button>

        <div className="mt-3 text-center text-[11px] text-white/70">
          By submitting you agree to be contacted regarding your enquiry.
        </div>
      </div>
    </div>
  );
};

export default LeadForm;
